export const useEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT || 'production';
};
